import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';

const PendingAds = () => {
  const dispatch = useDispatch();
  const { pendingAds, loadingPendingAds } = useSelector((state) => state.general);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(100);

  useEffect(() => {
    const fetchPendingAds = () => {
      dispatch(generalSet({ reduxField: 'loadingPendingAds', value: true }));
      dispatch(
        apiAction({
          reduxField: 'pendingAds',
          route: 'pendingAds/getPendingAds',
          page,
          size,
          setLoading: 'loadingPendingAds',
        })
      );
    };
    fetchPendingAds();
  }, [dispatch, page, size]);
  console.log({ pendingAds });

  const columns = [
    {
      field: '_id',
      headerName: 'Pending ID',
      width: 250,
      renderCell: (params) => <Link to={`/pendingAd/${params.value}`}>{params.value}</Link>,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 150,
      renderCell: (params) =>
        params.row.newAdId ? <span className='text-success'>Duplicated</span> : <span>Not Duplicated</span>,
    },
    { field: 'originalAdId', headerName: 'Original Ad ID', width: 200 },
    { field: 'newAdId', headerName: 'New Ad ID', width: 200 },
    { field: 'originalAccountId', headerName: 'Original Account ID', width: 200 },
    { field: 'originalCampaignId', headerName: 'Original Campaign ID', width: 200 },

    { field: 'newCampaignId', headerName: 'New Campaign ID', width: 200 },
    {
      field: 'ruleId',
      headerName: 'Rule ID',
      width: 200,
      renderCell: (params) => <Link to={`/rule/${params.value}`}>{params.value}</Link>,
    },
    { field: 'createdAt', headerName: 'Created At', width: 200 },
  ];

  return (
    <div className='mt-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center border-bottom'>
        <h1>Pending Ads</h1>
      </div>
      {Array.isArray(pendingAds) ? (
        <>
          <div className='row d-flex justify-content-center m-4'>
            <div style={{ height: 800, width: '100%' }}>
              <DataGrid
                rows={pendingAds.map((item, index) => ({ id: index, ...item }))}
                columns={columns}
                pageSize={5}
                rowsPerPageOptions={[5]}
              />
            </div>
          </div>
        </>
      ) : (
        <Spinner />
      )}
    </div>
  );
};

export default PendingAds;
